import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COLORS, EXTENDS, FONT_FAMILY } from '../constants/styles';
import ICONS from '../constants/icons';

import Icon from '../components/Icon';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { InfoTooltip } from './InfoTooltip';

const CheckboxWrapper = styled.a`
    position: relative;
`;

const Label = styled.label`
    align-items: center;
    padding-left: 30px;
    position: relative;
    cursor: pointer;
    height: 25px;
    display: flex;
    ${FONT_FAMILY.multipleRegularCss};
    font-size: 0.875rem;
    font-weight: 300;
    color: ${COLORS.redTitle};
    cursor: pointer;
    transition: font-weight 200ms ease-in;
    text-decoration: underline;
    &:hover {
        font-weight: bold;
    }
`;

const Input = styled.input`
    ${EXTENDS.isVisualyHidden};
    color: ${COLORS.rakutenRed};
`;

const Indicator = styled.span`
    position: absolute;
    left: 0;
    width: 25px;
    height: 25px;
    border: 2px solid;
    border-color: ${(props) => (props.active ? COLORS.rakutenRed : COLORS.grey)};
    padding: 5px;
    border-radius: 5px;
    background-color: ${(props) => (props.active ? COLORS.rakutenRed : COLORS.white)};

    &.error {
        background-color: ${COLORS.white};
        border-color: ${COLORS.rakutenRed};
    }
`;

const Tick = styled.span`
    width: 12px;
    height: 9px;
    display: block;
    color: ${COLORS.white};
`;

class CheckboxLink extends React.Component {
    render() {
        const { id, name, value, onChange, onBlur, ariaLabel, shownError, label, tooltipText } =
            this.props;

        return (
            <CheckboxWrapper href="#" onKeyDown={(event) => event.key === 'Enter' && onChange()}>
                <Label htmlFor={id}>
                    <Input
                        name={name}
                        id={id}
                        type="checkbox"
                        role="checkbox"
                        value={value}
                        checked={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        aria-label={ariaLabel}
                        tabIndex={-1}
                    />
                    <Indicator active={value} className={shownError ? 'error' : ''}>
                        {value && (
                            <Tick>
                                <Icon size="12" icon={ICONS.CHECK} />
                            </Tick>
                        )}
                    </Indicator>
                    {TranslationHelpers.getFormattedMessage(label)}
                </Label>
                {tooltipText ? <InfoTooltip id={id} tooltipText={tooltipText} /> : ''}
            </CheckboxWrapper>
        );
    }
}

CheckboxLink.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    ariaLabel: PropTypes.string,
    shownError: PropTypes.bool,
    label: PropTypes.string,
};

export default CheckboxLink;
